<!-- Modern App-like Time Tracking Page (v2) -->
<ng-container *ngIf="myAuthService.session$ | async as session">

  <div class="b2-page">

    <!-- ===== ZEITERFASSUNG SECTION (hidden in auto booking mode) ===== -->
    <section class="b2-card b2-card--dark" *ngIf="autoBookMode !== 1">
      <button class="b2-section-header" (click)="toggleSection('zeiterfassung')">
        <fa-icon [icon]="zeiterfassungOpen ? 'chevron-down' : 'chevron-right'" class="b2-section-icon"></fa-icon>
        <span class="b2-section-title">{{ 'txBuchungen.timeRegistration' | translate }}</span>
      </button>

      <div class="b2-section-body" *ngIf="zeiterfassungOpen">

        <!-- Auto Booking (single button) -->
        <div class="b2-btn-stack" *ngIf="session.bookAuto == 1">
          <button class="b2-btn b2-btn--primary b2-btn--lg" (click)="clickBookingButton('K')">
            <span class="b2-btn__label">{{ 'txBuchungen.booking' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="clock"></fa-icon></span>
          </button>
        </div>

        <!-- Arrive / Go -->
        <div class="b2-btn-stack" *ngIf="session.Kommen == 1">
          <!-- Arrive without cost centers -->
          <button class="b2-btn b2-btn--primary" (click)="clickBookingButton('K')" *ngIf="session.KST == 0">
            <span class="b2-btn__label">{{ 'txBuchungen.arrive' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="sign-in-alt"></fa-icon></span>
          </button>

          <!-- Arrive with cost centers (split button) -->
          <div class="b2-split-row" *ngIf="session.KST == 1">
            <div class="b2-split-button">
              <button type="button" class="b2-btn b2-btn--primary b2-split-button__main" (click)="clickBookingButton('K')">
                <span class="b2-btn__label">{{ 'txBuchungen.arrive' | translate }}</span>
              </button>
              <button type="button" class="b2-btn b2-btn--primary b2-split-button__caret" [matMenuTriggerFor]="kstMenuArriveB2" [attr.aria-label]="'txBuchungen.costCenters' | translate">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <mat-menu #kstMenuArriveB2="matMenu">
                <button mat-menu-item *ngFor="let k of kostenstellen" (click)="k.command()">{{ k.label }}</button>
              </mat-menu>
            </div>
          </div>

          <!-- Go Button -->
          <button class="b2-btn b2-btn--primary" (click)="clickBookingButton('G')">
            <span class="b2-btn__label">{{ 'txBuchungen.go' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="sign-out-alt"></fa-icon></span>
          </button>
        </div>

        <!-- Break -->
        <div class="b2-btn-stack" *ngIf="session.Pause == 1">
          <button class="b2-btn b2-btn--accent" (click)="clickBookingButton('PB')">
            <span class="b2-btn__label">{{ 'txBuchungen.beginOfBreak' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="arrow-right"></fa-icon></span>
          </button>
          <button class="b2-btn b2-btn--accent" (click)="clickBookingButton('PS')">
            <span class="b2-btn__label">{{ 'txBuchungen.endOfBreak' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="arrow-left"></fa-icon></span>
          </button>
        </div>

        <!-- Errand / Dienstgang -->
        <div class="b2-btn-stack" *ngIf="session.Dienstgang == 1">
          <button class="b2-btn b2-btn--secondary" (click)="clickBookingButton('DB')">
            <span class="b2-btn__label">{{ 'txBuchungen.beginOfErrand' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="clock"></fa-icon></span>
          </button>
          <button class="b2-btn b2-btn--secondary" (click)="clickBookingButton('DE')">
            <span class="b2-btn__label">{{ 'txBuchungen.endOfErrand' | translate }}</span>
            <span class="b2-btn__icon"><fa-icon icon="clock"></fa-icon></span>
          </button>
        </div>
      </div>
    </section>

    <!-- ===== QUICK ACCESS / DIREKTWAHL SECTION ===== -->
    <section class="b2-card b2-card--dark"
             *ngIf="session.BDE == 1 && (quickAccessEntries$ | async)?.length > 0">
      <button class="b2-section-header" (click)="toggleSection('quickAccess')">
        <fa-icon [icon]="quickAccessOpen ? 'chevron-down' : 'chevron-right'" class="b2-section-icon"></fa-icon>
        <span class="b2-section-title">{{ (quickAccessTitle$ | async) || ('txBuchungen.quickAccess' | translate) }}</span>
      </button>

      <div class="b2-section-body" *ngIf="quickAccessOpen">
        <div class="b2-chip-grid" *ngIf="quickAccessEntries$ | async as entries">
          <button class="b2-chip" *ngFor="let entry of entries" (click)="startQuickAccessBooking(entry)">
            <fa-icon icon="bolt" class="b2-chip__icon"></fa-icon>
            <span class="b2-chip__label">{{ entry.bezeichnung }}</span>
          </button>
        </div>
      </div>
    </section>

    <!-- ===== BDE SECTION (if BDE enabled) ===== -->
    <section class="b2-card b2-card--dark b2-card--bde" *ngIf="session.BDE == 1">
      <button class="b2-section-header" (click)="toggleSection('bde')">
        <fa-icon [icon]="bdeOpen ? 'chevron-down' : 'chevron-right'" class="b2-section-icon"></fa-icon>
        <span class="b2-section-title">{{ 'tx-bde.assignment' | translate }}</span>
      </button>

      <div class="b2-section-body" *ngIf="bdeOpen">
        <tx-bde [modern]="true"></tx-bde>
      </div>
    </section>

    <!-- ===== USER STATUS / BENUTZERSTATUS SECTION ===== -->
    <section class="b2-card b2-card--dark" *ngIf="!pinLoggedIn">
      <button class="b2-section-header" (click)="toggleSection('userStatus')">
        <fa-icon [icon]="userStatusOpen ? 'chevron-down' : 'chevron-right'" class="b2-section-icon"></fa-icon>
        <span class="b2-section-title">{{ 'txBuchungen.userState' | translate }}</span>
      </button>

      <div class="b2-section-body" *ngIf="userStatusOpen">
        <!-- Welcome info card -->
        <div class="b2-welcome" *ngIf="listOfUserInfo">
          <div class="b2-welcome__row">
            <span class="b2-welcome__greeting">
              {{ 'tx-welcome.welcome' | translate }} {{ listOfUserInfo?.name }}
            </span>
            <span class="b2-welcome__status"
                  [ngClass]="{
                    'b2-welcome__status--online': listOfUserInfo?.status == '1',
                    'b2-welcome__status--offline': listOfUserInfo?.status != '1'
                  }">
              <fa-icon icon="circle"></fa-icon>
            </span>
          </div>
          <div class="b2-welcome__info" *ngIf="listOfUserInfo?.user_info"
               [innerHTML]="listOfUserInfo.user_info"></div>
          <div class="b2-welcome__fs" *ngIf="listOfUserInfo?.fs_control == 1">
            {{ 'txTeamleiter.driverLicenseCheck' | translate }}
          </div>
        </div>

        <!-- Offline bookings badge -->
        <div class="b2-badge-row" *ngIf="(queueSize$ | async)?.length > 0">
          <span class="b2-badge">
            <fa-icon icon="cloud-upload-alt"></fa-icon>
            {{ 'txBuchungen.bookingsInQueue' | translate }}: {{ (queueSize$ | async)?.length }}
          </span>
        </div>

        <!-- User state selector -->
        <div class="b2-state-select">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'txBuchungen.chooseState' | translate }}</mat-label>
            <mat-select [(ngModel)]="SelectedState" (selectionChange)="setUserState()">
              <mat-option *ngFor="let state of UserStates$ | async" [value]="state.value">
                {{ state.label | translateOrText: 'userStates.' }}
              </mat-option>
            </mat-select>
            <div matSuffix class="b2-state-clear">
              <button class="b2-icon-btn b2-icon-btn--subtle"
                      (click)="SelectedState = '0'; setUserState(); $event.stopPropagation()">
                <fa-icon icon="times"></fa-icon>
              </button>
            </div>
          </mat-form-field>
        </div>
      </div>
    </section>

    <!-- ===== DRIVER'S LICENSE CONTROL ===== -->
    <section class="b2-card b2-card--dark b2-card--license"
             *ngIf="listOfUserInfo?.fs_control == 1 && (isMobile || isTablet) && goodConnection && !pinLoggedIn">
      <div [ngClass]="{ 'b2-disabled-overlay': !networkIsOnline }">
        <tx-imageupload
          (upload)="onFileUpload($event)"
          [(blockui)]="blockImageUploadUi"
          [forceDesktop]="false"
          [title]="'txTeamleiter.driverLicenseCheck' | translate"
          [description]="'txBuchungen.fsPhotoPrompt' | translate"
          [chooseLabel]="'txBuchungen.startPhoto' | translate">
        </tx-imageupload>
      </div>
    </section>

  </div>

  <!-- ===== FLOATING ACTION BUTTON (only in auto booking mode) ===== -->
  <button class="b2-fab" *ngIf="autoBookMode === 1" (click)="clickBookingButton('K')">
    <fa-icon icon="clock" class="b2-fab__icon"></fa-icon>
    <span class="b2-fab__label">{{ 'txBuchungen.booking' | translate }}</span>
  </button>

</ng-container>
